/*
 * @Descripttion:
 * @Author: zenghua.wang
 * @Date: 2021-11-03 17:50:22
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2021-11-04 11:53:37
 * https://www.58pic.com/
 */
const files = require.context('.', false, /\.png$/)
let fileList = []

files.keys().forEach((key) => {
  if (key === './index.js') return

  let fileName = key.replace(/(\.\/|\.png)/g, '')
  if (fileName) {
    fileList.push({
      name: fileName,
      url: require('@/dragComponents/public/images/border/' +
        key.replace(/(\.\/)/g, ''))
    })
  }
})

export default fileList
